import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=31e7d475&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/scss/_main.scss?vue&type=style&index=0&id=31e7d475&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7d475",
  null
  
)

export default component.exports